import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { WaybillIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { ShipmentWaybillEndpoint } from '../../constants/shipment-waybill-endpoint';
import { ShipmentWaybillMilestoneModel } from '../../models/shipment-waybill-milestone.model';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillTrackingService {
  constructor(private http: WrapperHttpService) {}

  getMilestonesData(waybillIdView: WaybillIdView): Observable<{ milestones: ShipmentWaybillMilestoneModel[] }> {
    const url = `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
      ShipmentWaybillEndpoint.Milestones
    }?${getQueryStringFromObject({
      ...waybillIdView,
    })}`;

    return this.http.withLoading().get(url);
  }
}
